import { render, staticRenderFns } from "./PredmetRail.vue?vue&type=template&id=3ad9fdc4&scoped=true&"
import script from "./PredmetRail.vue?vue&type=script&lang=js&"
export * from "./PredmetRail.vue?vue&type=script&lang=js&"
import style0 from "./PredmetRail.vue?vue&type=style&index=0&id=3ad9fdc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad9fdc4",
  null
  
)

export default component.exports